if(typeof jQuery == 'undefined'){
 document.write('<script type="text/javascript" src="ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></'+'script>');
}
document.write('<link href="https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap" rel="stylesheet">');
$(function(){
  var delayTime = 500;
  // click event for menu init..
  $(document).on( 'click', '.EarnRewards_Point', function(){
    var customer = $(this).data('customer');
    if( customer ){
      $('.EarnRewards_Point').fadeOut( delayTime, function(){
        $('.__closeStampe').css('visibility','visible');
        //show welcome screen
        $('.WelcomeScreen').fadeIn();
      });
    }else{
      $('.__registerNew').fadeIn( delayTime, function(){
        $('body').addClass('stamped');
      });
    }
  });
  
  // click event for register form
  $(document).on('click','._registerMe', function(){
    $('.__registerNew').fadeOut( delayTime, function(){
      $('._customerRegister').fadeIn( delayTime, function(){
        $('body').addClass('stamped');
      });
    });
  });
  
  // click for close popup if click outside of form while popup opended
  $('body').on('click', function(e){
    if($(event.target).hasClass('Main_Popup')){
      $('.Main_Popup').fadeOut( delayTime, function(){
        $('body').removeClass('stamped');
      });
    }
  });
  
  // click event for login screen
  $(document).on('click', '.__loginMe', function(){
    $('.__registerNew').fadeOut( delayTime, function(){
      $('.loginForm').fadeIn( delayTime, function(){
        $('body').addClass('stamped');
      });
    });
  });
  
  // click event for dismiss links
  $(document).on('click', '.dismiss', function(){
    $(this).closest('div.Main_Popup').fadeOut( delayTime, function(){
      $('body').removeClass('stamped');
    });
  });
  
  // click event for register link 
  $(document).on('click','._registerMeLink', function(){
    $(this).closest('div.Main_Popup').fadeOut( delayTime, function(){
      $('._customerRegister').fadeIn( delayTime, function(){
        $('body').addClass('stamped');
      });
    });
  });
  
  // click event close form button
  $(document).on('click', '.__closeStampe', function(){
    $(this).css( 'visibility','hidden' );
    $('.WelcomeDiv').fadeOut( delayTime, function(){
      $('.EarnRewards_Point').fadeIn();
    });
  });
  
  // click event for my rewards
  $(document).on('click', '._myrewards', function(){
    $('._step1').fadeOut( delayTime, function(){
      $('._step2').fadeIn();
      $('._myrewards, ._howitworks').hide();
      
    });
    $(this).parent('.__MyRewards').prev().find('.__Back').attr('back','_step1');
    
  });
  
  $(document).on('click', '._howitworks', function(){
    
    $('.WelcomeDiv').fadeOut( delayTime, function(){
      $('.EarnRewards_Point').fadeIn();
      $('._how_it_works').fadeIn();
      $('.__closeStampe').css( 'visibility','hidden' );
    });
  });
  $(document).on('click', '.__close_how_work', function(){
      $('._how_it_works').fadeOut();
  });
  $(document).on('click', '.__close_reward_notify', function(){
      $('#new_reward_popup').fadeOut();
  });
  
  // click event for back
  $(document).on('click', '.__Back', function(){
    var _back = $(this).attr('back');
    $(this).parents('div[class^="_step"]').fadeOut( delayTime, function(){
      $('.'+_back).fadeIn();
      $('._myrewards, ._howitworks').fadeIn();
    });  
    
  });
  
  // making ajax request
  var form = new FormData();
  setTimeout(function(){ updateStamps_data(); }, 10000);
  setTimeout(function(){ updateStamps_data(); }, 15000);
  setTimeout(function(){ updateStamps_data(); }, 20000);
  var totalStamps = 20;
  $(document).ready(function(){
    updateLabels();
  	updateStamps_data();
  });
});
function updateLabels() {
  $.ajax({
        url : "https://joyinabottleph.com/apps/stamp-me-proxy/getprograminfo.php",
        type: "GET",
        success: function(data, textStatus, jqXHR)
        {
          var response = JSON.parse(data);
          if(response.status == 'OK') {
            var programmInfoData = response.data;
            totalStamps = programmInfoData.total_stamps_on_a_card ;
            updateStamps(0);
            $.each(programmInfoData, function( index, programmInfo) {
              if (typeof programmInfo == 'string' || typeof programmInfo == 'number') {
              }else if(typeof programmInfo == 'object') {
                $.each(programmInfo, function( index2, programmInfo2) {
					if (typeof programmInfo2 == 'string' || typeof programmInfo2 == 'number') {
                      $(`.${index}-${index2}`).html(programmInfo2);
              		}else if(typeof programmInfo2 == 'object') {
                      $.each(programmInfo2, function( index3, programmInfo3) {
                          if (typeof programmInfo3 == 'string' || typeof programmInfo3 == 'number') {
                            if(index3 == 'url') {
                              $(`.${index}-${index2}-${index3}`).attr('href', programmInfo3);
                            }else {
                            	$(`.${index}-${index2}-${index3}`).html(programmInfo3);
                            }
                          }

                      });
                    }

                });
              }
              console.log(typeof programmInfo+" and index"+index);
            });
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
        }
    });  
}
function displayNewRewardPop(userdata) {
  var cookiename = `current_rewards_${userdata.user.shopify_id}`;  
  var new_rewards = userdata.user.current_rewards.length;
  var currentRewards =  getCookie(cookiename);
  if(currentRewards != 'nothing') {
    if(new_rewards > currentRewards && !$('#new_reward_popup').hasClass('new_reward_oppend')) {
    	$("#new_reward_popup").addClass('new_reward_oppend').show(); 
      	document.cookie = `${cookiename}=${new_rewards}`;
    }else {
    	$("#new_reward_popup").removeClass('new_reward_oppend').hide();   
    }
  }else {
  	document.cookie = `${cookiename}=${new_rewards}`;
  }  
}
function updateStamps_data() {
    var userID = $('.EarnRewards_Point').data('customer');
    var email = $('.EarnRewards_Point').data('customer_email');
    var fname = $('.EarnRewards_Point').data('customer_fname');
    var lname = $('.EarnRewards_Point').data('customer_lname');
    if(userID) {
    $.ajax({
        url : "https://joyinabottleph.com/apps/stamp-me-proxy/",
        type: "POST",
        data : {userId: userID, email: email, fname: fname, lname:lname},
        success: function(data, textStatus, jqXHR)
        {
          var userdata = JSON.parse(data);
          var current_rewards = userdata.data.user.current_rewards;
          if(userdata.unclaimed_awards) {
            
          }else {
            	
          }
          if(current_rewards.length > 0) {
            var text = `${current_rewards.length} rewards to claim`;
            if(current_rewards.length == 1) {
              var text = `${current_rewards.length} reward to claim`;
            }
          	$('.unclaimed_rewards').html(text);
			
          	$(".__MyRewards .__counter, .stamplogoimg .__counter" ).html( current_rewards.length).show();
			
          }else {
            $('.unclaimed_rewards').html(`Earn Rewards`);
            $(".__MyRewards .__counter, .stamplogoimg .__counter").hide();
          }
          displayNewRewardPop(userdata.data);
          updateStamps(userdata.data.user.active_stamps);
          if(current_rewards.length) {
              var html = "";
              $.each(current_rewards, function (i, reward) {
                  if(reward.discount_code) {
                      html+= `<div class="single_reward"><span class="__title">${reward.discount_code}</span><span onclick="claim_reward(this, ${reward.id})" class="__button">Applied</span></div>`;
                  }else {
                      html+= `<div class="single_reward"><span class="__title">${reward.name}</span><span onclick="claim_reward(this, ${reward.id})" class="__button">Claim Now</span></div>`;
                  }
              });
              $(".My_Reward_Content_inner").html(html);
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
        }
    });
    }else {
      $(".__MyRewards .__counter").hide();
      console.log("user is not logged in"); 
    }
  }
function updateStamps(stampsCount) {
  //if(stampsCount > 0) {
    var i; var html = "";
    for(i = 1; i <= totalStamps ; i++) {
      if(i <= stampsCount) {
        html+=`<li>
              <a href="#">
                <span class="stamp_logo_red">
                  <img src="//cdn.shopify.com/s/files/1/0270/7770/5751/t/1/assets/stamp_logo_red.png?v=12786785543448730561" alt="">
                </span>
              </a>
            </li>`; 
      }else {
        html+=`<li>
            <a href="#">
              <span class="stamp_logo_red">
              </span>
            </a>
          </li>`;
      }      
    }
  	/*html+=`<li>
            <a href="#">
              <span class="stamp_logo_red GiftImg">
                <img src="//cdn.shopify.com/s/files/1/0270/7770/5751/t/1/assets/gift.png?v=17340025711859626264" alt="">
              </span>

            </a>
          </li>`;*/
    $('.__StampMe').html(html);
  //}
}
function claim_reward(button, rewardId) {
  var userID = $('.EarnRewards_Point').data('customer');
  	//$('.My_Reward_Content').addClass('ajax_processing');
  $('.My_Reward_Content').append('<div class="ajax_overlay"></div>');
    $.ajax({
        url : "https://joyinabottleph.com/apps/stamp-me-proxy/claimReward.php",
        type: "POST",
        data : {rewardId: rewardId, userID: userID},
        success: function(data, textStatus, jqXHR)
        {
            var response = JSON.parse(data);
            if(response.status == 'OK') {
              if(response.data.unclaimed_rewards) {
                var text = `${response.data.unclaimed_rewards} rewards to claim`;                
                if(response.data.unclaimed_awards == 1) {                  
                  var text = `${response.data.unclaimed_rewards} reward to claim`;
                }
                $('.unclaimed_rewards').html(text);
              }else {
                    $('.unclaimed_rewards').html(`Earn Rewards`);
              }              
              	var CouponCode = response.data.discount.code;
              	var customerId = response.data.customer;             
             	 document.cookie = "CouponCode=" + CouponCode;
             	 document.cookie = "logincustId=" + customerId;              
              	setDiscountPara();
                $('.single_reward').find('.__button').html('Applied');
              	$('.single_reward').find('.__title').html(CouponCode);
              	$('.ajax_overlay').remove();
            }else {
              alert(response.errors.title);
            }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
        }
    });  
}


function applycode(button) {
  var rewardId = jQuery(button).val();
  var userID = jQuery('.EarnRewards_Point').data('customer');
  	//$('.My_Reward_Content').addClass('ajax_processing');
  jQuery('.My_Reward_Content').append('<div class="ajax_overlay"></div>');
    jQuery.ajax({
        url : "https://joyinabottleph.com/apps/stamp-me-proxy/claimReward.php",
        type: "POST",
        data : {rewardId: rewardId, userID: userID},
        success: function(data, textStatus, jqXHR)
        {
            var response = JSON.parse(data);
            if(response.status == 'OK') {
              if(response.data.unclaimed_rewards) {
                var text = `${response.data.unclaimed_rewards} rewards to claim`;
                if(response.data.unclaimed_awards == 1) {
                  var text = `${response.data.unclaimed_rewards} reward to claim`;
                }
                jQuery('.unclaimed_rewards').html(text);
              }else {
                    jQuery('.unclaimed_rewards').html(`Earn Rewards`);
              }
              	var CouponCode = response.data.discount.code;
              	var customerId = response.data.customer;
              
             	 document.cookie = "CouponCode=" + CouponCode;
             	 document.cookie = "logincustId=" + customerId;
              
              	setDiscountPara();
              	jQuery("#myInputcode").val(CouponCode);
              jQuery(".applied_text").show();
              
              setTimeout(function(){
              	jQuery(".applied_text").hide();
              },20000);
              
              	jQuery(".apply-code-btn").val(rewardId);
              	jQuery('.ajax_overlay').remove();
            }else {
              alert(response.errors.title);
            }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
        }
    });  
}
function redeemStamp(couponCode) {
  var userID = jQuery('.EarnRewards_Point').data('customer');
    jQuery.ajax({
        url : "https://joyinabottleph.com/apps/stamp-me-proxy/redeemStamp.php",
        type: "POST",
          data : {couponCode: couponCode, userID: userID},
        success: function(data, textStatus, jqXHR)
        {
          var response = JSON.parse(data);
          if(response.status == 'OK') {
            alert("success"); 
          }else {
            alert(response.errors.title);
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
        }
    });
  }
jQuery(document).ready(function(){
  var custlogedId = jQuery('.EarnRewards_Point').data('customer');
  if(custlogedId>0){
      if(getCookie('logincustId') !='' && custlogedId==getCookie('logincustId')){
        if(getCookie('CouponCode') !='' && getCookie('CouponCode') !='nothing'){
          var discountcode = getCookie('CouponCode');          
           setTimeout(function(){ 
            if(jQuery("input[name=discount]").length>0){
              jQuery("input[name=discount]").val(discountcode);
            }else{
				jQuery('form.cart').append('<input type="hidden" id="discount" name="discount" value="'+discountcode+'">');
            }
           },1500);
        }
      } else{
        document.cookie = 'CouponCode=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'logincustId=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';         
      }
	}else{
      document.cookie = 'CouponCode=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'logincustId=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}  
   jQuery("input[name='checkout']").on('click',function(){
    	document.cookie = 'CouponCode=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'logincustId=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    });	
});
function setDiscountPara(){
  var custlogedId = jQuery('.EarnRewards_Point').data('customer');  
	if(custlogedId>0){
      if(getCookie('logincustId') !='' && custlogedId==getCookie('logincustId')){
        if(getCookie('CouponCode') !='' && getCookie('CouponCode') !='nothing'){         
          var discountcode = getCookie('CouponCode');          
            if(jQuery("input[name=discount]").length>0){
              jQuery("input[name=discount]").val(discountcode);
            }else{
               jQuery('form.cart').append('<input type="hidden" id="discount" name="discount" value="'+discountcode+'">');
            }          
        }
      } else{
         document.cookie = 'CouponCode=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'logincustId=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
  }else{
  		document.cookie = 'CouponCode=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = 'logincustId=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }  
}
function getCookie(name) {
  var custlogedId = jQuery('.EarnRewards_Point').data('customer');
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }else{
  	return 'nothing';
  }
}
